/**
 * "You're clear for today" (13-09, mock `.allclear`): the lotus blooms and the words settle. Under
 * reduced motion it is simply there (the global rule makes the keyframes instant). No look-ahead,
 * no upsell (CONTEXT): one quiet link to Done today, the way back to anything finished.
 */

import { useEffect, useRef } from 'react';
import styles from './today.module.css';

export interface AllClearProps {
  /** Move focus here (the last card just left with focus in it). */
  takeFocus: boolean;
  onShowDone: () => void;
}

export default function AllClear({ takeFocus, onShowDone }: AllClearProps) {
  const heading = useRef<HTMLHeadingElement | null>(null);

  useEffect(() => {
    const active = document.activeElement;
    if (takeFocus && (!active || active === document.body)) heading.current?.focus({ preventScroll: true });
  }, [takeFocus]);

  return (
    <div className={styles.allclear}>
      <img src="/logos/harmony-flower.png" alt="" />
      <h2 ref={heading} tabIndex={-1}>
        You&rsquo;re clear for today.
      </h2>
      <p>Everything that needed you is done.</p>
      <button type="button" className={styles.link} onClick={onShowDone}>
        See Done today
      </button>
    </div>
  );
}
